import { scaleLinear } from 'd3-scale';
import { device, IconSvg } from 'monica-alexandria';
import React from 'react'
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components'

const StatisticsRetention = styled.div`
  padding: var(--smallPads);
`
const ColorBox = styled.div`
  width: 2rem;
  height: 1rem;
  background-color: ${props => props.color};
  border-radius: 0.3rem;
`;



const Legend = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 4rem;
  font-size: 1rem;
  align-items: center;
  justify-content: right;

  svg{
    width: 2rem;
  }

  .loyal{
   
    fill: #a2f6a9;
    
  }
   .returning{
    fill: #f9f871;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
`;


const MatrixWrapper = styled.div`
  overflow-x: auto;
  padding-bottom: 1rem;

  ${Row} {
    min-width: max-content;
  }
`;

const Cell = styled.div`
  width: 5rem;
  height: 5rem;
  border-radius: 0.5rem;

  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.05);
  }

  @media ${device.md}{
    width: 2.8rem;
    height: 2.8rem;
  }
`;

const CellContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-weight: bold;
  text-align: center;
  line-height: 1.4;


  .details p {
    font-size: 1.2rem;
    opacity: 0.9;
  }

  p{
    color: var(--white);
  }

  ${props => props.value < 10 ? `color: #333;` : `color: #fff;`}
  @media ${device.md}{
     p {
      font-size: .8rem;
    }
  }

`;

const CellContentDetails = styled.div`

  p  {
    font-size: 1.3rem;
    display: inline-block ;
    padding: .5rem;
  }
  .loyal{
    color: #a2f6a9;
  }
  .returning{
    color: #f9f871;
  }
  .bulletReturning svg  {
    width: .2rem;

    .bulletReturning {
      width: .2rem;
      fill: var(--focus);

    }
  }


  @media ${device.md}{
    p  {
      font-size: .5rem;
      padding: .1rem;
    }
  }

`

const ColumnTitle = styled.div`
  width: 5rem;
  height: 5rem;
  transform: rotate(-45deg);
  transform-origin: left bottom;
  white-space: nowrap;
  display: flex;
  align-items: end;
  justify-content: start;

  @media ${device.md}{
    width: 2.8rem;
    height: 2.8rem;
  }
`;

export default function Statistics_Retention(props) {
    const {t} = useTranslation();
    const theme = useTheme();
    
    const flatValues = props.structuredData.flat().map(cell => cell.sum || 0);

    const maxValue = Math.max(...flatValues, 1); // prevent division by zero
    const mainLight = getComputedStyle(document.documentElement).getPropertyValue('--mainLight').trim() || '#d6e685';
    const mainDark = getComputedStyle(document.documentElement).getPropertyValue('--mainDark').trim() || '#1e6823';

    const colorScale = scaleLinear()
    .domain([0, maxValue])
    .range([mainLight, mainDark]);
    


    console.log('xlabel', props.xLabels);
    
  return (
    <StatisticsRetention>
       <MatrixWrapper>
        
        <Row>
            {props.xLabels?.map((label, i) => (
                <ColumnTitle key={i}><p>{label}</p></ColumnTitle>
            ))}
        </Row>

        {props.structuredData?.map((row, i) => (
            <Row key={i}>
                {row.map((cellData, j) => {
                    
                    const sum = cellData.sum || 0;
                    const base = row[0]?.sum || 1; // first cell of the row as cohort basess
                    // const retentionRate = ((sum / base) * 100).toFixed(1);
                    const backgroundColor = sum === 0 ? theme.mid : colorScale(sum);

                    return (
                        <Cell key={j} style={{ backgroundColor }} title={`Total: ${sum}, Loyal: ${cellData.loyal || 0}, Returning: ${cellData.returning || 0}`}>
                            {sum > 0 && (
                                <CellContent value={sum}>
                                    <span className="sum"><p>{sum}</p></span>
                                    {/* <p>{retentionRate}%</p> */}
                                    <CellContentDetails>
                                        <p className='loyal'>{cellData.loyal || 0}</p>
                                        <p className='returning'>{cellData.returning || 0}</p>
                                     
                                    </CellContentDetails>
                                </CellContent>
                            )}
                        </Cell>
                    );
                })}
            </Row>
        ))}
       </MatrixWrapper>

         <Legend>
            {/* <span>{t('Legend')}:</span>
            <ColorBox color={mainLight} /> <span>0</span>
            <ColorBox color={mainDark} /> <span>{`≥ ${maxValue}`}</span> */}
            <ColorBox color={mainLight} /> <p>0</p>
            <ColorBox color={mainDark} /> <p>{`≥ ${maxValue}`}</p>
            
            <ColorBox color={'#a2f6a9'} /> <p>{t('Loyal')}</p>
            <ColorBox color={'#f9f871'} /> <p>{t('Returning')}</p>
            {/* <IconSvg Icon='Asterisk'  class_Icon='loyal' />
            <p className='loyal'>Loyal</p>
        
            <IconSvg Icon='Asterisk' class_Icon='returning' />
            <p className='returning' >Returning</p> */}
        </Legend>
    </StatisticsRetention>
  )
}
